// Function for svg sprite
function requireAll(r) {
    r.keys().forEach(r);
}

requireAll(require.context('../images/sprite-images/', true, /\.svg$/));


//Modification comments 
const commentModerations = document.querySelectorAll('.comment-awaiting-moderation');

commentModerations.forEach(commentModeration => {
    commentModeration.parentElement.classList.add('comment-body--moderation');
})
